import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

// Import helpers
import { fetchSubscriptionSettings } from 'helpers/configurator';
import { convertDaysToMonths } from 'helpers/time';

export const useConfiguratorSettings = () => {
	const { i18n } = useTranslation();

	const { data = null } = useQuery({
		queryKey: 'configurator_settings',
		queryFn: fetchSubscriptionSettings,
		select: (settings) => {
			const [unit, period] = convertDaysToMonths(settings.billing_cycle_days, i18n.language).split(' ');
			return { ...settings, billing_duration: { unit, period } };
		}
	});

	return data;
};
